module.exports = __webpack_public_path__ + "static/media/kyc_fingerprint.72b8d4b5.svg";